export const TransitionType = {
  SceneToScene: 'sceneToScene',
  SceneCoverScene: 'sceneCoverScene'
} as const;
export type TransitionTypeKeys = keyof typeof TransitionType;
export type TransitionTypeValues = typeof TransitionType[TransitionTypeKeys];
